import { render, staticRenderFns } from "./UpgradeTemplateRevisionDialog.vue?vue&type=template&id=06f6dcb1&scoped=true"
import script from "./UpgradeTemplateRevisionDialog.vue?vue&type=script&lang=js"
export * from "./UpgradeTemplateRevisionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f6dcb1",
  null
  
)

export default component.exports